import _get from 'lodash/get';

export default (user) => _get(user, 'attributes.email', null);
